import styled from 'styled-components';

export const ContainerCreatePassword = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* min-height: 100vh; */
`;

export const ContainerImg = styled.div`
  margin: 45px 0px 60px;
`;
export const BoxAuth = styled.div`
  margin: 0 auto;
  padding: 24px 20px;
  width: 340px;
  background: #ffffff;
  border-radius: 15px;
  -webkit-box-shadow: 5px 15px 15px 0px rgba(171, 193, 221, 0.5);
  -moz-box-shadow: 5px 15px 15px 0px rgba(171, 193, 221, 0.5);
  box-shadow: 5px 15px 15px 0px rgba(171, 193, 221, 0.5);
  font-family: 'Fira Sans', sans-serif;
`;

export const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 500;
  margin-bottom: 0.8em;
  margin-top: 0.2em;
  color: #ffaa00;
`;

export const DivInp = styled.div`
  margin-bottom: 10px;

  img {
    position: absolute;
    margin-top: -22px;
    margin-left: 270px;
    cursor: pointer;
  }
`;

export const Input = styled.input`
  border-radius: 5px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px;
  border: 1px solid;
`;

export const ContainerBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;

  span {
    cursor: pointer;
  }
`;
export const ButtonSub = styled.button`
  -webkit-appearance: none;
  background-color: #0d84ff;
  border: none;
  font-family: 'Fira Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  border-radius: 5px;
  padding: 8px 12px 8px 12px;
  box-shadow: 2px 2px 7px #acc2f9bf;
`;
